import React from "react";
import {
  parse,
  startOfMonth,
  endOfMonth,
  format,
  startOfYear,
  endOfYear,
  subYears,
} from "date-fns";
import styles from "./style.module.scss";
import Button from "../../../../components/new-button";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../assets/svg/icons/common/Filter";
import RedDotBadge from "../../../../assets/svg/icons/common/RedDotBadge";
import SettingsIcon from "../../../../assets/svg/icons/common/SettingsIcon";
import MonthPicker from "../../../../components/form/month-picker";
import useUserStore from "../../../../stores/user";
import useDashboardStore from "../../../../stores/dashboard";
import Settings from "../settings";

function getDashboardFilterCount(filterData) {
  if (!filterData) return 0;
  let count = 0;
  if (filterData.filterUser) count++;
  if (filterData.filterOrg) count++;
  count += filterData.cards?.length ?? 0;
  return count;
}

const Header = () => {
  const user = useUserStore((state) => state.user);
  const setFilterDrawerOpen = useDashboardStore(
    (state) => state.setFilterDrawerOpen,
  );
  const filterData = useDashboardStore((state) => state.filterData);
  const filterCount = getDashboardFilterCount(filterData);
  const setFilterData = useDashboardStore((state) => state.setFilterData);
  const setSettingOpen = useDashboardStore((state) => state.setSettingOpen);  
  const settingOpen = useDashboardStore((state) => state.settingOpen);

  const handleMonthPickerChange = (data) => {
    let startDate, endDate;
    const currentDate = new Date();

    if (["MTD", "LTY", "YTD"].includes(data.month)) {
      if (data.month === "YTD") {
        startDate = startOfYear(currentDate);
        endDate = currentDate;
      } else if (data.month === "MTD") {
        startDate = startOfMonth(currentDate);
        endDate = currentDate;
      } else if (data.month === "LTY") {
        const lastYearDate = subYears(currentDate, 1);
        startDate = startOfYear(lastYearDate);
        endDate = endOfYear(lastYearDate);
      }
    } else {
      const parsedDate = parse(
        `${data.month} ${data.year}`,
        "MMM yyyy",
        new Date()
      );
      startDate = parsedDate;
      endDate = endOfMonth(parsedDate);
    }

    setFilterData({
      startDate: format(startDate, "MM/dd/yyyy"),
      endDate: format(endDate, "MM/dd/yyyy"),
    });
  };

  return (
    <>
      <div className={styles.mobile_header}>
        <div className={styles.mobile_filters}>
          <div className={styles.month_picker_wrapper}>
            <MonthPicker
              variant="smallFilter"
              supportMobile
              onSubmit={handleMonthPickerChange}
              changeOnSubmit
              showYearFilters
              showActions
              onOpenChange={(open) => {
                if (open) {
                  setSettingOpen(false);
                }
              }}
            />
          </div>
          <ButtonIcon
            bgColor="#EDEDF4"
            onClick={() => {
              setSettingOpen(false);
              setFilterDrawerOpen(true);
            }}
            className={styles.filter_button}
          >
            <span className={styles.filterIconWrapper}>
              <Filter />
              {filterCount > 0 && (
                <RedDotBadge className={styles.filter_active} />
              )}
            </span>
            <span className={styles.filter_button_label}>
              Filter
              {filterCount > 0 ? `: ${filterCount}` : ""}
            </span>
          </ButtonIcon>
          <ButtonIcon
            bgColor="#EDEDF4"
            onClick={() => setSettingOpen(!settingOpen)}
            className={styles.filter_button}
          >
            <SettingsIcon />
          </ButtonIcon>
        </div>
        {settingOpen && (
          <div className={styles.mobile_settingContainer}>
            <Settings />
          </div>
        )}
      </div>

      <div className={styles.headingContainer}>
        <div className={styles.headingLeft}>
          <h1 className={styles.headingLeftTitle}>
            Hello, {user?.name?.split(" ")[0]}
          </h1>
          <h5 className={styles.headingLeftSubtitle}>
            Here is statistics for all your organizations
          </h5>
        </div>

        <div className={styles.headingRight}>
          <MonthPicker
            variant="largeFilter"
            supportMobile
            onSubmit={handleMonthPickerChange}
            changeOnSubmit
            showYearFilters
            showActions
            onOpenChange={(open) => {
              if (open) {
                setSettingOpen(false);
              }
            }}
          />

          <Button
            size="large"
            variant="secondary"
            condensedX
            onClick={() => {
              setSettingOpen(false);
              setFilterDrawerOpen(true);
            }}
          >
            <div className={styles.filterIconContainer}>
              <span className={styles.filterIconWrapper}>
                <Filter width={24} className={styles.filterIcon} />
                {filterCount > 0 && (
                  <RedDotBadge className={styles.filterEnabledDot} />
                )}
              </span>
              <span>
                Filter
                {filterCount > 0 ? `: ${filterCount}` : ""}
              </span>
            </div>
          </Button>

          <Button size="large" variant="ghost" condensedX style={{ gap: "0" }} > 
            <span onClick={() => setSettingOpen(!settingOpen)} ><SettingsIcon /></span>   
            {settingOpen && (
              <span className={styles.settingContainer}>
                <Settings />
              </span>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

export default Header;
